@import 'tailwindcss';

/* Load the old Javascript Tailwind config file until migrated to CSS based config used by Tailwind 4 */
@config '../../tailwind.config.ts';

@theme {
  --font-display:
    'Inter', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue',
    Helvetica, Arial, 'Lucida Grande', sans-serif;
}

@layer utilities {
  .text-balance {
    text-wrap: balance;
  }
}
